module.exports = __webpack_public_path__ + "static/img/bg-fr.512782f6.png";